// extracted by mini-css-extract-plugin
export default {"reviewsBlock":"ReviewsBlock_reviewsBlock__nnovH"};